import { usePage } from '@inertiajs/inertia-vue3'
import { useGtm } from '@gtm-support/vue-gtm'

// Zákaznické stránky, kde se načítá GTM rezervační stránky. Administrace má
// na editaci rezervační stránky prop se stejným názvem. Seznam musí sedět
// s podmínkou v resources/views/app.blade.php.
const CLIENT_COMPONENTS = /^(ReservationWizard|ClientReservations|PickUp)\//

let loadedGtmId = null

// Průvodce vložený v iframu patří webu, který ho vkládá. Kontejner načtený
// s dokumentem proto měří celý dokument a znovu se nenačítá: v iframu bez
// cookies drží session jen token v hlavičce XHR a celé načtení by
// rozpracovanou rezervaci ztratilo.
export const isEmbedded = (() => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
})()

// Neplatné nebo prázdné ID by @gtm-support shodilo celou aplikaci.
export function gtmIdOf(page) {
  if (!CLIENT_COMPONENTS.test(page?.component ?? '')) return null
  const id = page.props?.reservationPage?.gtmId
  return /^GTM-[0-9A-Z]+$/.test(id ?? '') ? id : null
}

// Kontejner, který sám zobrazuje cookie lištu (Cookiebot apod.), si souhlas
// řídí sám a naše lišta by byla druhá. Viz cookie_consent_in_gtm u rezervační
// stránky, hlavička v resources/views/app.blade.php se řídí stejným propem.
export function consentInGtmOf(page) {
  return gtmIdOf(page) !== null && page.props.reservationPage.cookieConsentInGtm === true
}

export function setLoadedGtmId(id) {
  loadedGtmId = id
}

// Kontejner skutečně vykreslené stránky. Událost navigate od Inertie nese při
// návratu tlačítkem zpět stránku ze serveru, i když vykreslila tu z historie.
function renderedGtmId() {
  const page = usePage()
  return gtmIdOf({ component: page.component.value, props: page.props.value })
}

// Vykreslená stránka patří jinému kontejneru než načtenému a mimo iframe je
// potřeba celé načtení, aby měřil ten správný.
export function needsContainerReload() {
  return !isEmbedded && renderedGtmId() !== loadedGtmId
}

// GTM pro měřicí události. Volat až v okamžiku odeslání: Inertia vymění
// stránku a spustí onMounted dřív, než app.js stihne stránku znovu načíst,
// takže stránka jiného kontejneru by jinak měřila do cizího.
export function trackingGtm() {
  if (!loadedGtmId || needsContainerReload()) return null
  return useGtm()
}
